export default "__VITE_ASSET__c11c2d67__"